import { getUsersDisableContentTags } from '../../GlobalFunctions';
import { UserProfileType } from '../../../peekapak-types/DataProtocolTypes';

interface LibraryFilterType {
  applicationTags?: string[];
  displayName: string;
  displayNameForFreemium?: string;
  filterTags?: string[];
  value: string;
  valueForFreemium?: string;
}

// Extensible filter configuration by license level
// Add new license levels and their allowed filters here
const FILTER_CONFIG_BY_LICENSE: Record<string, string[]> = {
  // Takween users only see All, Middle School, and High School filters
  TAKWEEN: ['', 'middleSchool', 'highSchool'],
  // Add other custom license configurations here as needed
  // Example: ELEMENTARY_ONLY: ['', 'elementary', 'supplementary', 'video'],
};

// License levels that should have filters completely hidden
// To show some filters for these licenses, remove from this array and configure in FILTER_CONFIG_BY_LICENSE
export const HIDE_FILTERS_FOR_LICENSE: string[] = ['TAKWEEN'];

// Default filters available to all users (unless overridden by license config)
export const filters: LibraryFilterType[] = [
  {
    displayName: 'All',
    value: '',
    displayNameForFreemium: 'Free Resources',
    valueForFreemium: 'freemium',
  },
  { displayName: 'Elementary', value: 'elementary' },
  { displayName: 'Middle School', value: 'middleSchool' },
  { displayName: 'High School', value: 'highSchool' },
  { displayName: 'Supplementary', value: 'supplementary' },
  { displayName: 'Video Lessons', value: 'video' },
  { displayName: 'Music', value: 'music', applicationTags: ['music-joanna'] },
  { displayName: 'How To Resources', value: 'howTo' },
  { displayName: 'Posters', value: 'posters' },
  { displayName: 'Extras', value: 'extras' },
];

export const getFilters = (userProfile?: UserProfileType | null) => {
  const userDisableTags = getUsersDisableContentTags() || [];

  // First, check if user has a license level with specific filter configuration
  const licenseLevel = userProfile?.licenseLevel;
  let allowedFilters: LibraryFilterType[] = filters;

  if (licenseLevel && FILTER_CONFIG_BY_LICENSE[licenseLevel]) {
    // User has a custom filter configuration - only show specified filters
    const allowedFilterValues = FILTER_CONFIG_BY_LICENSE[licenseLevel];
    allowedFilters = filters.filter((filter) => allowedFilterValues.includes(filter.value));
  }

  // Then apply the existing application tag filtering
  const final: LibraryFilterType[] = allowedFilters.filter((filter) => {
    if (!filter.applicationTags) return true;
    const anyExcludeTagsMatched = filter.applicationTags.some((tag) => {
      return userDisableTags.includes(tag);
    });

    return !anyExcludeTagsMatched;
  });
  return final;
};
